import { API2_HOST } from '../../helpers/urlHelper';
import {
  baseSearch,
  basePost,
  basePatch,
  baseGetWithoutParam
} from 'services/base-services/baseService';

const baseURL = `${API2_HOST}/bs-sector-measurables`;
const search = async request => {
  return await baseSearch(baseURL, request);
};

const post = async request => {
  return await basePost(baseURL, request);
};

const patch = async (id, request) => {
  return await basePatch(baseURL, request, id);
};

const getBoardMesuarables = async id => {
  return await baseGetWithoutParam(baseURL + '/board-measurable' + '?id=' + id);
};

export { search, post, patch, getBoardMesuarables };
